module.exports = __webpack_public_path__ + "static/media/ann_christiansen_headshot.99b976e9.png";